import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

// Super-admin view of Buy IMPROVE purchases paid by invoice
// (improve-api Billing container, /billing/invoices). Direct only.
export default {
  getInvoices: function(params, search, status) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/billing/invoices" + params + search + status);
  },
  // A payment that arrived outside Stripe (a transfer to our own bank):
  // pays the Stripe invoice out of band, the webhook then provisions.
  markPaid: function(uuid, note) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/billing/invoices/" + uuid + "/mark-paid", { note: note });
  },
};
